
  var _styles = {
  "threeColumnCard": {
    "display": "flex",
    "flexDirection": "column",
    "width": "3.01333rem",
    "height": "5rem",
    "backgroundColor": "rgb(255,255,255)",
    "borderRadius": "0.16rem",
    "marginBottom": "0.16rem",
    "overflow": "hidden"
  },
  "threeColumnImageWrapper": {
    "position": "relative",
    "width": "3.01333rem",
    "height": "2.26667rem"
  },
  "threeColumnImage": {
    "width": "3.01333rem",
    "height": "2.26667rem"
  },
  "threeColumnTopTag": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "height": "0.42667rem",
    "paddingLeft": "0.16rem",
    "paddingRight": "0.16rem",
    "borderRadius": "0 0 0.16rem 0",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "threeColumnTopTagText": {
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.26667rem",
    "color": "rgb(255,255,255)"
  },
  "threeColumnLocationOverlay": {
    "position": "absolute",
    "bottom": 0,
    "left": 0,
    "right": 0,
    "height": "0.53333rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "paddingLeft": "0.2rem",
    "paddingRight": "0.10667rem"
  },
  "threeColumnLocationIconWrapper": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "marginRight": "0.13333rem"
  },
  "threeColumnLocationText": {
    "fontFamily": "PingFang SC",
    "fontWeight": "400",
    "fontSize": "0.26667rem",
    "color": "rgb(255,255,255)",
    "lineHeight": "0.53333rem",
    "flex": 1,
    "maxWidth": "100%"
  },
  "threeColumnContent": {
    "display": "flex",
    "flexDirection": "column",
    "paddingTop": "0.14667rem",
    "paddingRight": "0.16rem",
    "paddingBottom": "0.14667rem",
    "paddingLeft": "0.16rem"
  },
  "threeColumnName": {
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.32rem",
    "color": "rgb(17,17,17)",
    "lineHeight": "0.45333rem",
    "height": "0.90667rem",
    "marginBottom": "0.10667rem",
    "overflow": "hidden"
  },
  "threeColumnTags": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "minHeight": "0.42667rem",
    "marginBottom": "0.21333rem"
  },
  "threeColumnTagItem": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "borderRadius": "0.08rem",
    "paddingTop": 0,
    "paddingRight": "0.08rem",
    "paddingBottom": 0,
    "paddingLeft": "0.08rem",
    "borderWidth": "0.01333rem",
    "borderStyle": "solid",
    "borderColor": "rgb(255,226,188)",
    "marginRight": "0.08rem"
  },
  "threeColumnTagItemText": {
    "fontFamily": "PingFang SC",
    "fontWeight": "400",
    "fontSize": "0.26667rem",
    "color": "rgb(255,75,16)",
    "lineHeight": "0.37333rem"
  },
  "threeColumnBottom": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "space-between",
    "alignItems": "center"
  },
  "threeColumnPriceWrapper": {
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "center",
    "maxWidth": "1.57333rem",
    "height": "0.8rem"
  },
  "threeColumnPriceSymbol": {
    "fontFamily": "MTNewDigitalDisplay-Bold",
    "fontWeight": "700",
    "fontSize": "0.32rem",
    "color": "rgb(255,65,0)"
  },
  "threeColumnPrice": {
    "fontFamily": "MTNewDigitalDisplay-Bold",
    "fontWeight": "700",
    "color": "rgb(255,65,0)"
  },
  "threeColumnPriceQi": {
    "fontFamily": "PingFang SC",
    "fontWeight": "400",
    "fontSize": "0.29333rem",
    "color": "rgb(136,136,136)"
  },
  "threeColumnOriginalPrice": {
    "fontFamily": "PingFang SC",
    "fontWeight": "400",
    "fontSize": "0.26667rem",
    "color": "rgb(153,153,153)",
    "textDecoration": "line-through",
    "WebkitTextDecorationColor": "#999",
    "textDecorationColor": "#999",
    "marginTop": "-0.08rem"
  },
  "threeColumnBuyButton": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center",
    "width": "1.12rem",
    "height": "0.64rem",
    "borderRadius": "0.64rem"
  },
  "threeColumnBuyText": {
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.32rem",
    "color": "rgb(255,255,255)",
    "lineHeight": "0.64rem"
  }
};



  module.exports = _styles;
  